import { theme as uiTheme } from '@conteg/ui';
import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = { ...uiTheme, providerColor: '#ffc000' };
